<template>
  <div class="popover-option-list">
    <slot />
  </div>
</template>

<script lang="ts" setup></script>

<style lang="scss" scoped>
.popover-option-list {
  border-radius: 0.5rem;
  border: 0.063rem solid var(--neutral-10, #eaeaeb);
  overflow: hidden;
  background-color: var(--bg-base);
}
</style>
